var map = {
	"./en/baoming2.png": "eeq9",
	"./es/baoming2.png": "nQCG",
	"./pt/baoming2.png": "kLz6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "55Ki";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/baoming2\.png$
// module id = 55Ki
// module chunks = 0